/**
 * Threshold (% of SLA elapsed) at which a case flips from `healthy` to
 * `warning` in `deriveRiskLevel`. Business rule: surface cases at 75% of
 * their SLA so managers have meaningful lead time to intervene before a
 * breach. Adjust here if product wants a different lead-time.
 */
export const WARNING_PERCENT = 75;

/**
 * Rolling window (in days) of case-records the Workforce Console considers
 * "active work" — `findCaseRecords` is server-side filtered by
 * `created_at_after: now - LOOKBACK_DAYS`. Keep small so the per-team fan-out
 * stays cheap and the grid only shows what a manager actually needs to act on.
 */
export const LOOKBACK_DAYS = 7;
